APPS.resources.page = (function(){
	var show = function(){
		APP.getView().showChildView("mainRegion", new resourcesView())
		
		window.document.title = 'RESOURCES';
		if(typeof ga !== "undefined" ){ ga('send','pageview',{ page:"/", title:'RESOURCES' }) } 
	}
	
	// VIEW 
	
	var resourcesView = Mn.View.extend({
		className: "resources"
		,template: _.template($("#template_resources").html())
		,initialize: function(){
			$("a.link[href='/resources']").addClass("active")
		}
	})
	
	return {
		show: show
	}
})();


